var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{staticStyle:{"width":"800px"},attrs:{"border":"","columns":_vm.columns1,"data":_vm.row}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }